/**
 * @generated SignedSource<<fa54c382c57b1040ecd5688667256929>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BankTransactionDirection = "IN" | "OUT" | "%future added value";
export type BankTransactionGroup = "CUSTOMER_PAYMENTS" | "FINANCING" | "OTHER" | "SALARIES" | "SUPPLIERS" | "TAX_OFFICE" | "TRANSFER" | "%future added value";
export type BankTransactionRuleField = "COUNTERPARTY_NAME" | "PURPOSE" | "%future added value";
export type ChangeBankTransactionRuleInput = {
  containedText: string;
  direction?: BankTransactionDirection | null | undefined;
  field: BankTransactionRuleField;
  id: string;
  transactionGroup: BankTransactionGroup;
};
export type EditBankTransactionRuleDialogChangeMutation$variables = {
  input: ChangeBankTransactionRuleInput;
};
export type EditBankTransactionRuleDialogChangeMutation$data = {
  readonly changeBankTransactionRule: {
    readonly containedText: string;
    readonly direction: BankTransactionDirection | null | undefined;
    readonly field: BankTransactionRuleField;
    readonly id: string;
    readonly transactionGroup: BankTransactionGroup;
  };
};
export type EditBankTransactionRuleDialogChangeMutation = {
  response: EditBankTransactionRuleDialogChangeMutation$data;
  variables: EditBankTransactionRuleDialogChangeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BankTransactionRule",
    "kind": "LinkedField",
    "name": "changeBankTransactionRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "field",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "containedText",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "direction",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "transactionGroup",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditBankTransactionRuleDialogChangeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditBankTransactionRuleDialogChangeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "db1c92c2370dae9c473c16f12bae4ce3",
    "id": null,
    "metadata": {},
    "name": "EditBankTransactionRuleDialogChangeMutation",
    "operationKind": "mutation",
    "text": "mutation EditBankTransactionRuleDialogChangeMutation(\n  $input: ChangeBankTransactionRuleInput!\n) {\n  changeBankTransactionRule(input: $input) {\n    id\n    field\n    containedText\n    direction\n    transactionGroup\n  }\n}\n"
  }
};
})();

(node as any).hash = "4ff90164745daa069dd5f16dbbb39cf7";

export default node;
